
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import "./MapSiteToSupervisor.css"; // reuse the same CSS
import apiService from "../../utils/apiservice";



const MapSiteToSupervisor = () => {
  const [supervisors, setSupervisors] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState("");
  const [assignedSites, setAssignedSites] = useState([]);
  const [availableSites, setAvailableSites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const [dialogOpen, setDialogOpen] = useState(false);
const [selectedSiteForTransfer, setSelectedSiteForTransfer] = useState(null);
const [newSupervisor, setNewSupervisor] = useState("");

  const API_URL = process.env.REACT_APP_API_DJANGO_URL;
  const token = localStorage.getItem("accessToken");
  const customerId = localStorage.getItem("customer_id");


  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Reset page when switching tabs or changing the supervisor
  useEffect(() => {
    setPage(0);
  }, [tabValue, selectedSupervisor]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const getConfig = () => ({
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: {},
  });

  // useEffect(() => {
  //   const fetchSupervisors = async () => {
  //     try {
  //       if (!customerId) return;
  //       const res = await axios.get(`${API_URL}/api/get_supervisors/${customerId}/`, getConfig());
  //       const supData = res.data.supervisors.map((sup) => ({
  //         id: sup.id.id,
  //         first_name: sup.firstName,
  //         last_name: sup.lastName,
  //       }));
  //       setSupervisors(supData);
  //     } catch {
  //       toast.error("Failed to fetch supervisors");
  //     }
  //   };
  //   fetchSupervisors();
  // }, [customerId]);



  useEffect(() => {
  const fetchSupervisors = async () => {
    try {
      if (!customerId) return;
      // const res = await axios.get(`${API_URL}/api/get_supervisors/${customerId}/`, getConfig());
      const res = await apiService.get(`/api/get_supervisors/${customerId}/`, {
          data: {}
        });
      
      const supData = res.data.supervisors.map((sup) => ({
        id: sup.id.id,
        first_name: sup.firstName,
        last_name: sup.lastName,
      }));
      setSupervisors(supData);

        // ✅ Automatically select the first supervisor
        if (supData.length > 0) {
          const firstSupervisorId = supData[0].id;
          setSelectedSupervisor(firstSupervisorId);
          fetchSites(firstSupervisorId); // fetch assigned & available sites

        }

      } catch {
        toast.error("Failed to fetch supervisors");
      }
    };
    fetchSupervisors();
  }, [customerId]);

  const fetchSites = async (supId) => {
    try {
      setLoading(true);
      // assigned
      const assignedRes = await axios.get(`${API_URL}/api/supervisor_sites/${supId}/`, getConfig());
      const assigned = assignedRes.data.sites.map((s) => ({
        id: s.site_id,
        name: s.name,
        asset_uuid: s.asset_id,
      }));
      setAssignedSites(assigned);

      // available
      const excludeUUIDs = assigned.map((s) => s.asset_uuid);
      const availRes = await axios.get(`${API_URL}/api/get_customer_availablesites/${customerId}/`, getConfig());
      const available = availRes.data.data
        .filter((s) => !excludeUUIDs.includes(s.asset_id))
        .map((s) => ({ id: s.site_id, name: s.name, asset_uuid: s.asset_id }));
      setAvailableSites(available);
    } catch {
      toast.error("Failed to fetch sites");
      setAssignedSites([]);
      setAvailableSites([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSupervisorChange = (e) => {
    const supId = e.target.value;
    setSelectedSupervisor(supId);
    if (supId) fetchSites(supId);
  };

  // const handleAction = async (site, action) => {
  //   const isAssign = action === "assign";
  //   const endpoint = isAssign ? "assign_site_supervisor" : "unassign_site_supervisor";

  //   try {
  //     await axios.post(`${API_URL}/api/${endpoint}/`, {
  //       supervisor_id: selectedSupervisor,
  //       asset_id: site.asset_uuid,
  //     }, getConfig());

  //     if (isAssign) {
  //       setAssignedSites([...assignedSites, site]);
  //       setAvailableSites(availableSites.filter((s) => s.id !== site.id));
  //     } else {
  //       setAvailableSites([...availableSites, site]);
  //       setAssignedSites(assignedSites.filter((s) => s.id !== site.id));
  //     }
  //     toast.success(`Site ${isAssign ? "assigned" : "unassigned"} successfully`);
  //   } catch {
  //     toast.error("Action failed");
  //   }
  // };


  const handleAction = (site, action) => {
  if (action === "assign") {
    assignSite(site);
  } else {
    // 🔥 OPEN DIALOG instead of API
    setSelectedSiteForTransfer(site);
    setDialogOpen(true);
  }
};


const assignSite = async (site) => {
  try {
    await axios.post(
      `${API_URL}/api/assign_site_supervisor/`,
      {
        supervisor_id: selectedSupervisor,
        asset_id: site.asset_uuid,
      },
      getConfig()
    );

    setAssignedSites([...assignedSites, site]);
    setAvailableSites(availableSites.filter((s) => s.id !== site.id));

    toast.success("Site assigned successfully");
  } catch {
    toast.error("Assign failed");
  }
};


const handleTransfer = async () => {
  if (!newSupervisor || !selectedSiteForTransfer) {
    toast.error("Please select a new supervisor");
    return;
  }

  try {
    await axios.post(
      `${API_URL}/api/unassign_site_supervisor/`,
      {
        old_supervisor_id: selectedSupervisor,
        new_supervisor_id: newSupervisor,
        asset_id: selectedSiteForTransfer.asset_uuid,
      },
      getConfig()
    );

    toast.success("Site transferred successfully");

    // ✅ Refresh data
    fetchSites(selectedSupervisor);

    // Close dialog
    setDialogOpen(false);
    setNewSupervisor("");
    setSelectedSiteForTransfer(null);

  } catch (err) {
    toast.error(err.response?.data?.error || "Transfer failed");
  }
};



  const getFilteredSites = () => {
    if (tabValue === 1) return assignedSites;
    if (tabValue === 2) return availableSites;
    return [...assignedSites, ...availableSites];
  };

  return (
    <Paper className="main-card-ui">
      <Box className="header-row">
        <TextField
          select
          label="Select Supervisor"
          value={selectedSupervisor}
          onChange={handleSupervisorChange}
          size="small"
          className="device-select-input"
        >
          {supervisors.map((sup) => (
            <MenuItem key={sup.id} value={sup.id}>{sup.first_name} {sup.last_name}</MenuItem>
          ))}
        </TextField>

        <Box className="badge-container">
          <div className="status-badge assigned">Assigned: {assignedSites.length}</div>
          <div className="status-badge available">Available: {availableSites.length}</div>
        </Box>
      </Box>

      <Box className="tabs-wrapper">
        <Tabs
          value={tabValue}
          onChange={(e, v) => setTabValue(v)}
          centered
          className="custom-tabs"
          TabIndicatorProps={{ style: { display: "none" } }}
        >
          <Tab label="All" />
          <Tab label="Assigned" />
          <Tab label="Available" />
        </Tabs>
      </Box>

      <TableContainer className="table-container-ui orange-table">
        {loading ? (
          <Box textAlign="center" p={5}><CircularProgress /></Box>
        ) : (
          <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell align="center">Site Name</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getFilteredSites().length === 0 ? (
                <TableRow>
                  <TableCell colSpan={2} align="center" style={{ padding: "20px", color: "#94a3b8" }}>
                    No sites found.
                  </TableCell>
                </TableRow>
              ) : (
                getFilteredSites().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((site) => (
                    <TableRow key={site.id}>
                      <TableCell align="center">{site.name}</TableCell>
                      <TableCell align="center">
                        {assignedSites.some((s) => s.id === site.id) ? (
                          <Button className="btn-unmap" onClick={() => handleAction(site, "unassign")}>Unassign</Button>
                        ) : (
                          <Button className="btn-map" onClick={() => handleAction(site, "assign")}>Assign</Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        )}

        {/* After </TableContainer> */}
        {!loading && getFilteredSites().length > 0 && (
          <div className="pagination-bar">
            <div className="rows-select">
              Rows per page:
              <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
              </select>
            </div>
            <div className="page-info">
              {page * rowsPerPage + 1}-
              {Math.min((page + 1) * rowsPerPage, getFilteredSites().length)} of {getFilteredSites().length}
            </div>
            <div className="page-arrows">
              <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
              <button
                disabled={(page + 1) * rowsPerPage >= getFilteredSites().length}
                onClick={() => setPage(page + 1)}
              >
                ›
              </button>
            </div>
          </div>
        )}
      </TableContainer>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
  <DialogTitle>Assign Site to New supervisors</DialogTitle>

  <DialogContent>
    <DialogContentText>
      Select a new supervisor 
    </DialogContentText>

    <Box sx={{ mt: 2 }}>
      <TextField
        select
        fullWidth
        label="Select New Supervisor"
        value={newSupervisor}
        onChange={(e) => setNewSupervisor(e.target.value)}
      >
        {supervisors
          .filter((sup) => sup.id !== selectedSupervisor) // exclude current
          .map((sup) => (
            <MenuItem key={sup.id} value={sup.id}>
              {sup.first_name} {sup.last_name}
            </MenuItem>
          ))}
      </TextField>
    </Box>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setDialogOpen(false)}>Cancel</Button>

    <Button
      variant="contained"
      color="primary"
      onClick={handleTransfer}
      disabled={!newSupervisor}
    >
     Assign New Supervisor
    </Button>
  </DialogActions>
</Dialog>

      <ToastContainer position="top-right" autoClose={2000} />
      
    </Paper>
    
  );
};

export default MapSiteToSupervisor;









